import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Combines multiple class names together, merges them using tailwind-merge,
 * and returns a single string of class names.
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Sanitizes a product slug to ensure it's URL-safe.
 * Replaces forward slashes with hyphens and cleans up multiple hyphens.
 * This prevents slugs like "cr-jl1561/jl162" from creating extra path segments.
 */
export function sanitizeSlug(slug: string | null | undefined): string {
  if (!slug) return '';
  return slug.replace(/\//g, '-').replace(/-+/g, '-').replace(/^-|-$/g, '');
}

/**
 * Generates a product detail URL with a sanitized slug.
 */
export function getProductConfigureUrl(slug: string | null | undefined): string {
  return `/products/${sanitizeSlug(slug)}`;
}
